var Handlebars = require("../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=container.escapeExpression;

  return "<div class=\"tab-item-content-wrapper\">\n\n    <div id=\"metadata_"
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : {},{"name":"id","hash":{},"data":data}) : helper)))
    + "\" class=\"tab-item-content\" data-resourceRepresentationType='"
    + alias1(container.lambda(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? depth0.model : depth0)) != null ? stack1.metadata : stack1)) != null ? stack1.meContent : stack1)) != null ? stack1.resourceRepresentationType : stack1), depth0))
    + "'></div>\n</div>\n\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/html/tabs/metadata.hbs
// module id = 80
// module chunks = 0